import { CaptchaImageStorage } from "./data";
export var getCaptchaImage = function getCaptchaImage() {
  var _CaptchaImageStorage$;
  return (_CaptchaImageStorage$ = CaptchaImageStorage.getInstance().getData()) !== null && _CaptchaImageStorage$ !== void 0 ? _CaptchaImageStorage$ : {
    image: '',
    key: ''
  };
};